module.exports = __webpack_public_path__ + "static/media/qr_code_new.ed1500dd.gif";